<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <header
      class="m-grid__item m-header"
      data-minimize-offset="200"
      data-minimize-mobile-offset="200"
    >
      <div class="m-container m-container--fluid m-container--full-height">
        <div class="m-stack m-stack--ver m-stack--desktop">
          <!-- BEGIN: Brand -->
          <div class="m-stack__item m-brand m-brand--skin-light">
            <div class="m-stack m-stack--ver m-stack--general">
              <div class="m-stack__item m-stack__item--middle m-stack__item--left m-brand__tools">
                <!-- BEGIN: Left Aside Minimize Toggle -->
                <a
                  href="javascript:;"
                  @click.prevent="toggleAside()"
                  id="m_aside_left_minimize_toggle"
                  class="m-brand__icon m-brand__toggler m-brand__toggler--right m--visible-desktop-inline-block"
                >
                  <span></span>
                </a>
                <!-- END -->
                <!-- BEGIN: Responsive Aside Left Menu Toggler -->
                <a
                  ref="toggleRef"
                  href="javascript:;"
                  @click.prevent="toggleAsideMobile()"
                  id="m_aside_left_offcanvas_toggle"
                  class="m-brand__icon m-brand__toggler m-brand__toggler--right m--visible-tablet-and-mobile-inline-block"
                >
                  <span></span>
                </a>
                <!-- END -->
              </div>
              <div class="m-stack__item m-stack__item--middle m-stack__item--right m-brand__logo">
                <router-link :to="{ name: 'wallet' }" class="m-brand__logo-wrapper">
                  <img
                    alt="logo"
                    src="./../../public/assets/demo/default/media/img/logo/carbon_primary_positive_RGB.png"
                  />
                </router-link>
              </div>
            </div>
          </div>
          <!-- END: Brand -->
        </div>
      </div>
    </header>
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <button
        @click.prevent="toggleAsideMobile()"
        class="m-aside-left-close m-aside-left-close--skin-dark"
        id="m_aside_left_close_btn"
      >
        <i class="la la-close"></i>
      </button>
      <sidebar ref="sidebarRef" v-on-clickaway="clickOutside"></sidebar>
      <div class="appWrapper m-grid__item m-grid__item--fluid m-wrapper position-relative">
        <transition name="slide-fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
<script>
import vue from "vue";
import sidebar from "../components/sidebar.vue";
import { mixin as clickaway } from "vue-clickaway";

export default {
  mixins: [clickaway],
  data() {
    return {};
  },
  computed: {},
  methods: {
    clickOutside(e) {
      if (e.target && e.target.offsetParent === this.$refs["toggleRef"]) {
        return;
      }
      if (window.innerWidth < 993) {
        $("body").removeClass("m-aside-left--on");
        $("#m_aside_left").removeClass("m-aside-left--on");
      }
    },
    toggleAside() {
      $("body")
        .toggleClass(" m-brand--minimize")
        .toggleClass("m-aside-left--minimize");
    },
    toggleAsideMobile() {
      $("body").toggleClass("m-aside-left--on");
      $("#m_aside_left").toggleClass("m-aside-left--on");
    }
  },
  beforeMount: function() {},
  mounted() {
    $("body").addClass(
      "dashboard m-content--skin-light2 m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-aside--offcanvas-default"
    );
  },
  components: {
    sidebar
  }
};
</script>